var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00943 10.6251L9.50902 7.36758H6.38326V5.25323C6.38326 4.3619 6.81978 3.49347 8.21986 3.49347H9.64077V0.719781C9.64077 0.719781 8.3516 0.5 7.1184 0.5C4.54363 0.5 2.86171 2.05982 2.86171 4.88439V7.36758H0V10.6251H2.86171V18.5H6.38326V10.6251H9.00943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.15dd080184b03267d16f8db6a5f284da.svg";
export { ForwardRef as ReactComponent };